/**
 * SUBSCRIPTION CORE CONSTANTS
 * 
 * Fundação do sistema de assinaturas Nexora.
 * 
 * Nenhum número mágico espalhado pelo projeto.
 * Todas as constantes centralizadas aqui.
 * 
 * @version 1.0.0
 */

/**
 * Duração padrão da assinatura em dias
 * Utilizado em: approveUser(), renewSubscription()
 */
export const DEFAULT_SUBSCRIPTION_DAYS = 30;

/**
 * Plano de assinatura padrão
 * Utilizado quando assinatura é criada
 */
export const DEFAULT_PLAN = 'manual';

/**
 * Ciclo de faturamento padrão
 * Utilizado quando assinatura é criada
 */
export const DEFAULT_BILLING_CYCLE = 'monthly';

/**
 * Contagem inicial de renovações
 * Utilizado quando assinatura é criada
 */
export const INITIAL_RENEWAL_COUNT = 0;

/**
 * Ciclos de faturamento permitidos
 */
export const BILLING_CYCLES = {
  MONTHLY: 'monthly',
  ANNUALLY: 'annually',
} as const;

/**
 * Tipos de planos permitidos
 */
export const SUBSCRIPTION_PLANS = {
  MANUAL: 'manual',
  AUTOMATIC: 'automatic',
  TRIAL: 'trial',
} as const;
